export default __webpack_public_path__ + "static/18946-99134a8ffd9167ea854da49599c5b462.jpg";